import {
  OpenUrlTarget,
  openURL,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Pressable, Text} from 'native-base';
import {ITextProps} from 'native-base';
import React, {Fragment} from 'react';
import {Platform} from 'react-native';
import {stripHtmlCode} from 'utils';

interface OfferTextProps extends ITextProps {
  text: string | undefined;
}

const OfferText: React.FC<OfferTextProps> = ({
  text,
  fontSize,
  ...textProps
}) => {
  if (!text) {
    return null;
  }

  const taglessText = stripHtmlCode(text);
  const phoneRegex = /((?:[-+() ]*\d){10,11})/g;
  const urlRegex =
    /(http(s)?:\/\/.)?([-a-zA-Z0-9@:%._+~#=]{2,63}\.)?[-a-zA-Z0-9@:%._+~#=]{2,63}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+~#?&//=]*)/g;
  const parts = taglessText.split(phoneRegex);

  const secondSplit = () => {
    const tempArray: string[] = [];
    const finalArray: string[] = [];
    parts.map(part => {
      if (!part.match(phoneRegex)) {
        const re = /(\r+|\n+)/g;

        tempArray.push(...part.split(re));
      } else {
        tempArray.push(part.trim());
      }
    });
    tempArray
      .filter(part => part !== '')
      .map(part => {
        if (!part.match(phoneRegex)) {
          finalArray.push(...part.split(' '));
        } else {
          finalArray.push(part);
        }
      });
    return finalArray.filter(part => part !== '');
  };

  return (
    <Text fontSize={fontSize} {...textProps}>
      {secondSplit().map((part, idx, array) => {
        return part.match(phoneRegex) ? (
          <Fragment key={idx}>
            {idx !== 0 && array[idx - 1] !== '\n' && array[idx - 1] !== '\r'
              ? ' '
              : null}
            {Platform.OS === 'web' ? (
              <Pressable
                key={idx}
                fontWeight={600}
                onPress={() => {
                  const item = part.match(phoneRegex);
                  if (item) {
                    openURL(`tel://${item[0]}`);
                  }
                }}
                _hover={{textDecoration: 'underline'}}>
                <Text key={idx} fontSize={fontSize}>
                  {part}
                </Text>
              </Pressable>
            ) : (
              <Text
                key={idx}
                fontWeight={600}
                onPress={() => {
                  const item = part.match(phoneRegex);
                  if (item) {
                    openURL(`tel://${item[0]}`);
                  }
                }}>
                {part}
              </Text>
            )}
          </Fragment>
        ) : part.match(urlRegex) ? (
          <Fragment key={idx}>
            {idx !== 0 && array[idx - 1] !== '\n' && array[idx - 1] !== '\r'
              ? ' '
              : null}
            {Platform.OS === 'web' ? (
              <Pressable
                key={idx}
                fontWeight={600}
                onPress={() => {
                  const item = part.match(urlRegex);
                  if (item) {
                    openURL(
                      item[0].includes('https://') ||
                        item[0].includes('http://')
                        ? item[0]
                        : 'https://' + item[0],
                      OpenUrlTarget.BLANK
                    );
                  }
                }}
                _hover={{textDecoration: 'underline'}}>
                <Text key={idx} fontSize={fontSize}>
                  {part}
                </Text>
              </Pressable>
            ) : (
              <Text
                key={idx}
                fontWeight={600}
                onPress={() => {
                  const item = part.match(urlRegex);
                  if (item) {
                    openURL(
                      item[0].includes('https://') ||
                        item[0].includes('http://')
                        ? item[0]
                        : 'https://' + item[0],
                      OpenUrlTarget.BLANK
                    );
                  }
                }}>
                {part}
              </Text>
            )}
          </Fragment>
        ) : (
          <Fragment key={idx}>
            {idx !== 0 &&
            array[idx - 1] !== '\n' &&
            array[idx - 1] !== '\r' &&
            !part.match(/^[.!?]$/g)
              ? ' ' + part
              : part}
          </Fragment>
        );
      })}
    </Text>
  );
};
export default OfferText;
